const GET_ORDER_LIST_DATA = 'ORDER_LIST/GET_ORDER_LIST_DATA';
const SEARCH_ORDER = 'ORDER_LIST/SEARCH_ORDER';

export {
  GET_ORDER_LIST_DATA,
  SEARCH_ORDER
};
